<template lang="html">
  <div>
    <FullScreenSpinner v-if="saving" />
    <Header currentMenu="Account" subMenu="Symbium Vendors" />
    <div class="dashboard-content-container ownerships-list gap-64">
      <div class="flex-box page-container">
        <Menu currentMenu="Symbium Vendors" class="desktop-only" />
        <div class="content">
          <div class="section">
            <h2 class="black bgap-48">Symbium Vendors</h2>
            <div v-if="loading">
              <div class="gap-3x" />
              <Spinner />
            </div>
            <div v-if="!loading">
              <SymbiumButton
                text="Add new vendor"
                :onClick="openNewVendorModal"
                :isSmall="true"
              />
              <div class="gap-3x" />
              <div v-for="vendor in vendors" :key="vendor.id">
                <div class="line-break" />
                <div class="gap-3x" />
                <div>
                  <div class="information-container">
                    <div class="information-row">
                      <div class="information-col">Vendor: {{vendor.name}}</div>
                      <div class="information-col vendor-type">Type: {{vendor.type}}</div>
                    </div>
                    <div class="information-row">
                      <div class="information-col">First Name: {{vendor.first_name}}</div>
                      <div class="information-col">Last Name: {{vendor.last_name}}</div>
                    </div>
                    <div class="information-row">
                      <div class="information-col">Status: {{vendor.status}}</div>
                      <div class="information-col">Phone: {{vendor.phone}}</div>
                    </div>
                    <div class="information-row">
                      <div class="information-col">Email: {{vendor.email}}</div>
                    </div>
                  </div>
                  <div class="button-group"> 
                    <SymbiumButton
                      text="Registration detail"
                      :onClick="() =>openVendorDetail(vendor)"
                      :isPrimary="true"
                      :isSmall="true"
                      :isDisabled="!vendor.vendor_registration_id"
                    />
                    <SymbiumButton
                      text="Designs"
                      :onClick="() => gotoListingsPage(vendor)"
                      :isPrimary="true"
                      :isSmall="true"
                    />
                    <SymbiumButton
                      text="Edit"
                      :onClick="() => openEditVendorModal(vendor)"
                      :isPrimary="true"
                      :isSmall="true"
                    />
                    <SymbiumButton
                      text="Suspend"
                      :onClick="() => suspend(vendor)"
                      :loading="loading"
                      :isPrimary="true"
                      :isSmall="true"
                      :isDisabled="!vendor.vendor_registration_id"
                      v-if="vendor.status === 'active'"
                    />

                    <SymbiumButton
                      text="Approve"
                      :onClick="() => approve(vendor)"
                      :loading="loading"
                      :isSmall="true"
                      :isDisabled="!vendor.vendor_registration_id"
                      v-if="vendor.status === 'suspended'"
                    />
                  </div>
                </div>
                <div class="gap-3x" />
              </div>
            </div>
            <div v-if="paginateData.page_count > 1">
              <div class="gap-3x" />
              <PaginationContainer
                :paginateData="paginateData"
                @page-change="reload"
                klass="section-field"
              />
            </div>
            <div class="gap-3x" />
          </div>
          <FooterHelper />
        </div>
      </div>
    </div>
    <ConfirmModal />
    <EditVendorModal @updated-vendors="() => reload(this.paginateData.page)" />
  </div>
</template>

<script>

import EditVendorModal from "./modals/EditVendorModal.vue";
import Header from 'src/components/dashboard/shares/Header.vue'
import Menu from 'src/components/dashboard/shares/Menu.vue'
import FooterHelper from 'src/components/dashboard/shares/FooterHelper.vue'
import Spinner from 'src/components/common/Spinner.vue'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import FullScreenSpinner from 'src/components/common/FullScreenSpinner.vue'
import ConfirmModal from "src/components/common/modals/ConfirmModal.vue";
import PaginationContainer from 'src/components/common/utility/PaginationContainer.vue'

import _ from 'lodash'

export default {
  components: {
    Header, Menu, FooterHelper, Spinner,SymbiumButton,
    FullScreenSpinner, ConfirmModal, EditVendorModal, PaginationContainer
  },
  data() {
    return {
      vendors: [],
      loading: false,
      saving: false,
      paginateData: { page: 1 },
    }
  },
  methods: {
    assignData(response) {
      this.loading = false
      this.vendors = response.data.vendors
      this.paginateData = _.pick(response.data, [
        "page_count",
        "per_page",
        "last_page",
        "first_page",
        "total_count",
        "page",
      ])
    },
    openVendorDetail(vendor) {
      this.$router.push(`/dashboard/vendor_details?id=${vendor.vendor_registration_id}&view_only=true`)
    },
    gotoListingsPage(vendor) {
      this.$router.push(`listings?vendorId=${vendor.ID}`)
    },
    openNewVendorModal() {
      this.$modal.show('edit-vendor-modal', {})
    },
    openEditVendorModal(vendor) {
      this.$modal.show('edit-vendor-modal', { vendor })
    },
    reload(page) {
      this.loading = true;
      this.$vendor.fetchVendors({ page }, this.assignData)
    },
    approve(vendor) {
      this.$modal.show('confirm-modal', {
        actionText: 'Approve',
        cancelText: 'Cancel',
        confirmMessage: 'Are you sure to approve this vendor?',
        confirmCallBack: () => this.sendApproveRequest(vendor),
        alert: false,
      })
    },
    sendApproveRequest(vendor) {
      this.$modal.hide('confirm-modal')
      this.loading = true
      this.$vendor.updateVendorRegistration(
        vendor.vendor_registration_id,
        { status: 'active' },
        () => this.reload(this.paginateData.page)
      )
    },
    suspend(vendor) {
      this.$modal.show('confirm-modal', {
        actionText: 'Suspend',
        cancelText: 'Cancel',
        confirmMessage: 'Are you sure to suspend this vendor?',
        confirmCallBack: () => this.sendSuspendRequest(vendor),
        alert: false,
      })
    },
    sendSuspendRequest(vendor) {
      this.$modal.hide('confirm-modal')
      this.loading = true
      this.$vendor.updateVendorRegistration(
        vendor.vendor_registration_id,
        { status: 'suspended' },
        () => this.reload(this.paginateData.page)
      )
    },
  },
  mounted() {
    this.loading = true;
    this.$user.fetchMe();
    this.$vendor.fetchVendors({ page: 1 }, this.assignData)
  },
}
</script>

<style lang="scss" scoped>
.information-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  .information-row {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;

    .information-col {
      width: 400px;

      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }

    .vendor-type {
      text-transform: capitalize;
    }
  }
}

.button-group {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.vendor-link {
  margin-top: 4px;
}
</style>
